import { Text } from '@/components/ui';
import { TrendingDownIcon, TrendingUpIcon } from 'lucide-react';

interface TotalizerCardProps {
  title: string;
  currentValue: number;
  monthlyChange: number;
  suffix?: string;
}

export function TotalizerCard({ title, currentValue, monthlyChange, suffix }: TotalizerCardProps) {
  return (
    <div className="bg-base-white border-transparent-dark-12 p-md gap-sm flex flex-col rounded-2xl border">
      <Text variant="label" strong>
        {title}
      </Text>
      <div>
        <Text variant="heading" size="md" strong>
          {currentValue}
          {suffix}
        </Text>
        <div className="gap-4xs flex items-center">
          <Text className="text-neutral-muted">
            {`${monthlyChange >= 0 ? '+' : ''}${monthlyChange}${suffix ? suffix : ''} que no mês passado`}
          </Text>
          {monthlyChange > 0 && <TrendingUpIcon size={16} className="text-success-default" />}
          {monthlyChange < 0 && <TrendingDownIcon size={16} className="text-error-default" />}
        </div>
      </div>
    </div>
  );
}
